import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output, SimpleChanges
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { PreviewEditTemplateSelectors } from '../../preview-edit-template/state/preview-edit-template.selectors';
import { AudioService } from '../../services/audio.service';
import { soundSoundIdURL, soundTTSUrl } from './twilio-voice-parameter.model';

@Component({
    selector: 'twilio-voice-parameter',
    templateUrl: './twilio-voice-parameter.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class TwilioVoiceParameterComponent implements OnInit, OnChanges {

    @Input() type;
    @Input() isOnlyPreview;
    @Input() ttsMessage;
    @Input() contextVariables;
    @Input() model;
    @Input() audioService: AudioService;
    @Input() playSequence;
    @Input() sequenceNumber;
    @Input() soundName;
    @Input() isAppointment;
    @Input() src;
    @Output() readonly isEnded: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() readonly selectedNodeChange: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    selectedNode: any;
    userAgent = '';
    playerStatus$: Observable<string>;
    percentElapsed$: Observable<string>;
    isLoadingNewTTSAudio$: Observable<boolean>;
    isLoading = false;
    ttsMessageX: '';

    private _subscription: Subscription = new Subscription();

    constructor(private previewEditTemplateSelector: PreviewEditTemplateSelectors) {
        this.isLoadingNewTTSAudio$ = previewEditTemplateSelector.selectIsModelProcessed();
    }

    play(): any {
       const audio: HTMLAudioElement = new Audio();
       audio.src = this.src;
       const newAudioService = new AudioService();
       newAudioService.setAudio(audio);
       this.audioService = newAudioService;
       this.setPlayerStatus(this.audioService);
       this.audioService.playAudio();
    }

    stop(): any {
        this.audioService.stopAudio();
    }

    setSelectedNode(event): void {
        this.selectedNode = event.currentTarget;
        this.selectedNodeChange.emit(this.selectedNode);
    }

    ngOnInit(): void {
        // NOTE: In safari, the audio duration is always coming as INFINITY (Known bug),
        // so we will not display the headPOS in that case.
        this.userAgent = window.navigator.userAgent;

        this.setPlayerStatus(this.audioService);
        if (Boolean(this.model)) {
          const templateVariable = this.getVariableWithoutPrefix(this.model);
          this._subscription.add(
            this.previewEditTemplateSelector.selectGetContextVariable()
              .subscribe((contextVariable) => {
                  this.ttsMessageX = contextVariable[`${templateVariable}`];
                  this.src = templateVariable.indexOf('Sound') !== -1
                      ? `${soundSoundIdURL}${this.ttsMessageX}`  // JACOB: This is confusing - using ttsMessage when it should be soundId
                      : `${soundTTSUrl}${this.ttsMessageX}`;
              }
            )
          );

          this._subscription.add(
            this.previewEditTemplateSelector.selectIsModelProcessed()
              .subscribe((isProcessed) => {
                this.isLoading = !isProcessed;
              })
          );
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.playSequence !== undefined) {
            // if the autoplay is selected powernova
            if (this.playSequence !== -1 && this.sequenceNumber === this.playSequence) {
                this.play();

                return;
            }

            if (this.playSequence === -1) {
               // this.stop();
            }
        }
    }

    private setPlayerStatus(audioService: AudioService): void {
      this.playerStatus$ = audioService.playerStatus$;
      this.percentElapsed$ = audioService.percentElapsed$;
      this.playerStatus$.subscribe(playerStatus => {
        if (playerStatus === 'ended') {
          this.isEnded.emit();
        }
      });
    }

    private getVariableWithoutPrefix(variable: string): string {
      return variable.split('.')[1];
    }
}
